module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/tfl_skype_banner.48c0f876f48cb72305956586f9594a42.png";